import SaveAndShare from '../Buttons/SaveAndShare';
import StartOver from '../Buttons/StartOver';
import LoginOrRegister from '../Buttons/LoginOrRegister';
import Logout from '../Buttons/Logout';
import AdvisorNotesMenuItem from '../Buttons/AdvisorNotes';

export default function MenuActions({ toggleMenuState, isAdvisorView }) {
	return (
		<>
			<AdvisorNotesMenuItem isAdvisorView={isAdvisorView}/>
			<SaveAndShare classes={['saveShare']} toggleMenuState={toggleMenuState} isAdvisorView={isAdvisorView} />
			<StartOver classes={['plain']} toggleMenuState={toggleMenuState} isAdvisorView={isAdvisorView} />
			<LoginOrRegister toggleMenuState={toggleMenuState} classes={['plain', 'loginRegister']} />
			<Logout classes={['plain', ['startover'], 'is-marginless', 'logout']} toggleMenuState={toggleMenuState} />
		</>
	);
}
